"use client";

import { useEffect, useState } from "react";

/**
 * False on the server and on the client’s first paint; true after mount.
 * Use before any UI that depends on `Date` / `Intl` / `window` so SSR HTML
 * matches the first client render (avoids React hydration #418).
 */
export function useClientMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
